import { IconSvg, IconSvgProps } from "./icon"

export default function LayoutSquare(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="M8.786 3.643H4.929c-.71 0-1.286.575-1.286 1.286v3.857c0 .71.575 1.285 1.286 1.285h3.857c.71 0 1.285-.575 1.285-1.285V4.929c0-.71-.575-1.286-1.285-1.286ZM19.071 3.643h-3.857c-.71 0-1.286.575-1.286 1.286v3.857c0 .71.576 1.285 1.286 1.285h3.857c.71 0 1.286-.575 1.286-1.285V4.929c0-.71-.575-1.286-1.286-1.286ZM8.786 13.929H4.929c-.71 0-1.286.575-1.286 1.285v3.857c0 .71.575 1.286 1.286 1.286h3.857c.71 0 1.285-.575 1.285-1.286v-3.857c0-.71-.575-1.285-1.285-1.285ZM19.071 13.929h-3.857c-.71 0-1.286.575-1.286 1.285v3.857c0 .71.576 1.286 1.286 1.286h3.857c.71 0 1.286-.575 1.286-1.286v-3.857c0-.71-.575-1.285-1.286-1.285Z" />
    </IconSvg>
  )
}
